import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LegalMarkdown"] */ "/app/src/app/legal/legal-markdown.tsx");
